/**
 * 程序化纹理缓存(方案 A2.4:零外部美术资产)。
 * 统一白色基底 → 供 ParticleContainer 按粒子 tint 上色;渐变纹理 256px 复用。
 */
import { Texture } from 'pixi.js';

const cache = new Map<string, Texture>();

function radial(size: number, stops: [number, string][]): Texture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const ctx = c.getContext('2d')!;
  const g = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
  for (const [pos, col] of stops) g.addColorStop(pos, col);
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, size, size);
  return Texture.from(c);
}

export const TEX = {
  /** 柔和光晕(白,tint 上色)——发光体光晕、雪片、事件粒子通用 */
  glow(): Texture {
    const k = 'glow';
    if (!cache.has(k)) cache.set(k, radial(256, [[0, 'rgba(255,255,255,1)'], [0.25, 'rgba(255,255,255,0.85)'], [1, 'rgba(255,255,255,0)']]));
    return cache.get(k)!;
  },
  /** 亮核(白,近实心小圆)——发光体亮核、火花 */
  core(): Texture {
    const k = 'core';
    if (!cache.has(k)) cache.set(k, radial(128, [[0, 'rgba(255,255,255,1)'], [0.55, 'rgba(255,255,255,1)'], [0.8, 'rgba(255,255,255,0.6)'], [1, 'rgba(255,255,255,0)']]));
    return cache.get(k)!;
  },
  /** 雨丝:竖直柔和线(白),用 scale 拉伸成 1×14 */
  streak(): Texture {
    const k = 'streak';
    if (!cache.has(k)) {
      const c = document.createElement('canvas');
      c.width = 8; c.height = 64;
      const ctx = c.getContext('2d')!;
      const g = ctx.createLinearGradient(0, 0, 0, 64);
      g.addColorStop(0, 'rgba(255,255,255,0)');
      g.addColorStop(0.5, 'rgba(255,255,255,1)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g;
      ctx.fillRect(2, 0, 4, 64);
      cache.set(k, Texture.from(c));
    }
    return cache.get(k)!;
  },
  /** 烛民水滴形身体(白,tint 上色);anchor 用 (0.5,1) 立于地面 */
  teardrop(): Texture {
    const k = 'teardrop';
    if (!cache.has(k)) {
      const w = 44, h = 88, c = document.createElement('canvas');
      c.width = w; c.height = h;
      const ctx = c.getContext('2d')!;
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      // 圆润水滴:底部宽圆,顶部收窄
      ctx.moveTo(w / 2, 6);
      ctx.bezierCurveTo(w * 0.86, h * 0.32, w * 0.92, h * 0.78, w / 2, h - 4);
      ctx.bezierCurveTo(w * 0.08, h * 0.78, w * 0.14, h * 0.32, w / 2, 6);
      ctx.closePath();
      ctx.fill();
      cache.set(k, Texture.from(c));
    }
    return cache.get(k)!;
  },
  /** 亮星十字光芒 */
  starCross(): Texture {
    const k = 'starCross';
    if (!cache.has(k)) {
      const size = 64, c = document.createElement('canvas');
      c.width = c.height = size;
      const ctx = c.getContext('2d')!;
      const g = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
      g.addColorStop(0, 'rgba(255,255,255,1)');
      g.addColorStop(0.5, 'rgba(255,255,255,0.25)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, size, size);
      ctx.strokeStyle = 'rgba(255,255,255,0.8)'; ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(size / 2, 6); ctx.lineTo(size / 2, size - 6);
      ctx.moveTo(6, size / 2); ctx.lineTo(size - 6, size / 2);
      ctx.stroke();
      cache.set(k, Texture.from(c));
    }
    return cache.get(k)!;
  },
};
